export default __webpack_public_path__ + "media/images/ui-bg_diagonals-thick_90_eeeeee_40x40-d987b086c6e96fb45055361de17ac08e.png";